<script lang="ts">
  import Cnavbar from "@/components/cnavbar.svelte";
  import { translate as tr } from "@script/i18n";
  import { ROUTE_STATS, StatsTabs } from "@script/routes.ts";
  import { Link, Page, Tab, Tabs, Toolbar } from "framework7-svelte";

  const TAB_MAP_ID = "tab-map";
  const DEFAULT_TAB = StatsTabs[0];
  let currentTitle = "";

  const updateTitle = (tab: typeof DEFAULT_TAB) => {
    if (tab.id === TAB_MAP_ID) {
      currentTitle = ""; // no title for Map, already has one
    } else {
      currentTitle = tr(tab.text);
    }
  };

  updateTitle(DEFAULT_TAB);

  const onTabShow = (tab: typeof DEFAULT_TAB) => {
    updateTitle(tab);
  };
</script>

<Page name="stats" class={"page-stats" + (currentTitle === "" ? " map-active" : "")} pageContent={false}>
  <Cnavbar title={currentTitle} />

  <Toolbar tabbar icons position="bottom">
    {#each StatsTabs as tab (tab.id)}
      <Link
        tabLink
        routeTabId={tab.id}
        href={`${ROUTE_STATS.slice(0, -1)}${tab.href}`}
        text={tr(tab.text)}
        iconMaterial={tab.icon}
        color={tab.color} />
    {/each}
  </Toolbar>

  <Tabs routable>
    {#each StatsTabs as tab (tab.id)}
      <Tab id={tab.id} class="page-content" onTabShow={() => onTabShow(tab)} />
    {/each}
  </Tabs>
</Page>

{#if false}
  <!-- force svelte to keep css classes -->
  <div class="page-stats map-active" />
{/if}

<style>
  :global(.page-stats.map-active) {
    background-image: none !important;
    background-color: #000 !important;
  }
</style>
